<div class="bp-pill-info">
	<ng-content></ng-content>
</div>
